var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83606 7.38461C8.83606 9.51935 7.10535 11.25 4.97028 11.25C2.8352 11.25 1.10449 9.51935 1.10449 7.38461C1.10449 5.24988 2.8352 3.51923 4.97028 3.51923C7.10535 3.51923 8.83606 5.24988 8.83606 7.38461Z",
    stroke: "#96F2AA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 4.61539C12.2501 6.75012 10.5194 8.48078 8.38434 8.48078C6.24926 8.48078 4.51855 6.75012 4.51855 4.61539C4.51855 2.48065 6.24926 0.75 8.38434 0.75C10.5194 0.75 12.2501 2.48065 12.2501 4.61539Z",
    stroke: "#96F2AA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/Connect.87c88667793bec54f90c8f12c25b830f.svg";
export { ForwardRef as ReactComponent };